module.exports = __webpack_public_path__ + "img/public/AdminIcons/contentManagementIcon.svg?3fc4d057";